<template>
  <!--=== banner ==========-->
  <div v-if="bannerTopo != ''" class="slider-area topo-cel">
    <div class="slider-height2 slider-bg4 hero-overly d-flex align-items-center"
      :style="{ backgroundImage: 'url(' + $imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-5 col-lg-6 col-md-6">
            <div class="hero-caption hero-caption2">
              <h2>{{ bannerTopo[0].itiNome }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--  final banner -->

  <!--=== noticias ==========-->
  <section v-if="listaBlog.length > 0" class="section-padding">
    <div class="container">
      <div class="row">
        <!--  noticias grandes -->
        <div class="col-lg-8 mb-5 mb-lg-0">
          <div class="blog_left_sidebar">
            <article v-for="noticia in primeiraNoticia" :key="noticia.itiId" class="blog_item">
              <div class="blog_item_img">
                <router-link :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)" style="text-decoration: none;">
                <img
                  :style="{ backgroundImage: 'url(' + $imgURL + noticia.insInstitucionalImagens[0].itgUrlImagem + ')' }"
                  class="card-img-avance" alt="">
                   </router-link>
                <div class="blog_item_date">
                  <h3>{{ formattedDateDia(noticia.itiData1) }}</h3>
                  <p>{{ formattedDateMes(noticia.itiData1) }}</p>
                </div>
              </div>
              <div class="blog_details blog_area">
                <router-link :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)"
                  class="d-inline-block">
                  <h2 class="blog-head">{{ noticia.itiNome }}</h2>
                </router-link>
                <p>{{ resumoCurto(noticia.itiResumo1) }}</p>
                <router-link :to="'/BlogDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)">
                  <p>Leia mais</p>
                </router-link>
              </div>
            </article>
          </div>
        </div>
        <!--  noticias pequenas -->
        <div class="col-lg-4">
          <div class="blog_right_sidebar">
            <aside class="single_sidebar_widget popular_post_widget">
              <h3 class="widget_title">News</h3>

              <div v-for="noticiaPequena in listaBlog" :key="noticiaPequena.itiId" class="media post_item">
                <div v-if="noticiaPequena.insInstitucionalImagens.length > 0">
                  <img :src="$imgURL + noticiaPequena.insInstitucionalImagens[0].itgUrlImagem" alt="post"
                    class="post-item-avance">
                </div>
                <div class="media-body">
                  <router-link :to="'/BlogDetalhe/' + noticiaPequena.itiId + '/' + formataLink(noticiaPequena.itiNome)">
                    <h3>{{ noticiaPequena.itiNome }}</h3>
                  </router-link>
                </div>
              </div>

            </aside>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- final noticias -->


</template>

<script>
import { useHead } from '@vueuse/head';
import axios from 'axios';

export default {
  name: 'BlogView',
  components: {
  },

  data: () => ({
    bannerTopo: [],
    listaBlog: [],
    noticia: [],
    noticiaPequena: [],
  }),

  computed: {
    primeiraNoticia() {
      return this.listaBlog.length > 0 ? this.listaBlog.slice(0, 2) : [];
    }
  },

  methods: {

    /* resumo curto da primeira noticia */
    resumoCurto(conteudo) {
      const textoLimpo = this.removerTagsHTML(conteudo);
      const limite = 200; // você pode ajustar esse número
      return textoLimpo.length > limite ? textoLimpo.slice(0, limite) + '...' : textoLimpo;
    },

    formattedDateDia(value) {
      return this.$moment(value).format('DD')
    },

    formattedDateMes(value) {
      const mes = this.$moment(value).format('MMMM')
      return mes.charAt(0).toUpperCase() + mes.slice(1)
    },

    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },

    carregaMetas(texto, titulo) {
      useHead({
        title: 'Igor Paper - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Igor Paper" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },

    filtraNoticia(categoria) {
      let _filtro = this.listaNoticias.filter(x => x.itiReferencia == categoria);
      this.firstNoticia = _filtro[0];
      this.otherNoticas = _filtro.slice(1, 6);
      this.finalNoticias = _filtro.slice(7);
    },

    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
  },

  created() {
    this.carregaMetas("---");

    // banner topo
    axios.get('/Process/InsInstitucional/institucional/45/blogtopo/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML(this.bannerTopo[0].itiReferencia), this.bannerTopo[0].itiNome);
        //console.log('banner blog')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    // noticias
    axios.get('/Process/InsInstitucional/institucional/46/listablog/0/itiData1')
      .then(response => {
        this.listaBlog = response.data.filter(x => x.itiVisivel).sort((a, b) => {
          const timeA = a.itiData1
            ? new Date(a.itiData1).getTime()
            : 0;
          const timeB = b.itiData1
            ? new Date(b.itiData1).getTime()
            : 0;
          return timeA - timeB;
        }).reverse();
        //console.log('noticias')
        //console.log(this.listaBlog)
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style scoped></style>